import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  updatedBookingData: {
    checkIn: null,
    checkOut: null,
    numberOfNights: null,
    stayDates: "",
    pricePerNight: null,
    totalPrice: null,
    type: null, 
    propertyImage: null,
    bookingID: null,
    guests: null,
    propertyName: null,
  },
};

const staySmallSmallUpdatedBookingDataSlice = createSlice({
  name: 'staySmallSmallUpdatedBookingData',
  initialState,
  reducers: {
    setUpdatedBookingData: (state, action) => {
      state.updatedBookingData = { ...state.updatedBookingData, ...action.payload };
    },
    clearUpdatedBookingData: (state) => {
      state.updatedBookingData = initialState.updatedBookingData;
    },
  },
});

export const { setUpdatedBookingData, clearUpdatedBookingData } = staySmallSmallUpdatedBookingDataSlice.actions;
export default staySmallSmallUpdatedBookingDataSlice.reducer;